module.exports = __webpack_public_path__ + "img/full0-min.950e45a7.png";